<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
          title="جزئیات بخشنامه"
        >
          <b-form
            ref="circularform"
            @submit.prevent
          >
            <b-row>

              <b-col
                class="mt-2 form-size"
                md="8"
              >
                <b-row>

                  <b-col md="12">
                    <b-form-group
                      label="پیوست"
                      label-for="attachment"
                    >
                      <b-form-file
                        id="attachment"
                        v-model="attachment"
                        placeholder="فایلی انتخاب نشده است"
                        browse-text="انتخاب فایل"
                        drop-placeholder="فایل را اینجا رها کنید"
                      />

                      <!-- پیش‌نمایش پیوست: هم فایلِ تازه انتخاب‌شده، هم پیوستِ قبلیِ ذخیره‌شده -->
                      <b-link
                        v-if="attachmentUrl"
                        :href="attachmentUrl"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="attachment-preview d-inline-flex align-items-center border rounded mt-1"
                      >
                        <span class="attachment-thumb d-flex align-items-center justify-content-center">
                          <b-img
                            v-if="attachmentIsImage"
                            :src="attachmentUrl"
                            class="attachment-thumb-img"
                          />
                          <feather-icon
                            v-else
                            :icon="attachmentIcon"
                            size="22"
                          />
                        </span>

                        <span class="attachment-info mx-1">
                          <span class="attachment-name d-block">{{ attachment ? attachmentName : 'پیوست فعلی' }}</span>
                          <small class="text-muted">
                            {{ attachment ? 'فایل انتخاب‌شده — برای مشاهده کلیک کنید' : 'برای مشاهده در تب جدید کلیک کنید' }}
                          </small>
                        </span>

                        <span
                          v-if="attachmentExt"
                          class="badge badge-light-primary text-uppercase"
                        >
                          {{ attachmentExt }}
                        </span>

                        <feather-icon
                          icon="EyeIcon"
                          size="18"
                          class="text-primary ml-1"
                        />
                      </b-link>
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group
                      label="عنوان"
                      label-for="Title"
                    >
                      <b-form-input
                        v-model="Form.Title"
                        name="Title"
                        autocomplete="off"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group
                      label="شماره نامه"
                      label-for="LetterNumber"
                    >
                      <b-form-input
                        v-model="Form.LetterNumber"
                        name="LetterNumber"
                        autocomplete="off"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group
                      label="تاریخ"
                      label-for="Date"
                    >
                      <date-picker
                        v-model="Form.Date"
                        placeholder=""
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group
                      label="تاریخ انقضا"
                      label-for="ExpiryDate"
                    >
                      <date-picker
                        v-model="Form.ExpiryDate"
                        placeholder=""
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="وضعیت"
                      label-for="IsActive"
                    >
                      <v-select
                        v-model="Form.IsActive"
                        :options="enums('IsActive')"
                        dir="rtl"
                        label="text"
                        :reduce="x => x.value"
                        :clearable="false"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                      label="دسته بندی کالا"
                      label-for="ProductCategoryId"
                    >
                      <z-product-category
                        v-model="Form.ProductCategoryId"
                        :multiple="true"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                      label="نوع سند"
                      label-for="CircularDocumentTypeId"
                    >
                      <z-circular-document-type
                        v-model="Form.CircularDocumentTypeId"
                        :multiple="true"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                      label="نوع فرآیند"
                      label-for="CircularProcessTypeId"
                    >
                      <z-circular-process-type
                        v-model="Form.CircularProcessTypeId"
                        :multiple="true"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                        label="گمرک"
                        label-for="CustomsId"
                    >
                      <z-customs
                          v-model="Form.CustomsId"
                          :multiple="true"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <b-form-group
                      label="تگ ها"
                      label-for="Tag"
                    >
                      <b-form-tags
                        v-model="Form.Tag"
                        name="Tag"
                        placeholder=""
                        add-button-text="افزودن"
                        add-button-variant="outline-primary"
                        @paste.native="onTagsPaste"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="12">

                    <b-form-group
                      label="توضیحات"
                      label-for="Description"
                    >
                      <z-quill-editor v-model="Form.Description" />
                    </b-form-group>

                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

import ZQuillEditor from '@/tools/quilleditor.vue'
import ZCircularProcessType from '@/tools/circularprocesstype.vue'
import ZCircularDocumentType from '@/tools/circulardocumenttype.vue'
import ZProductCategory from '@/tools/productcategory.vue'
import ZCustoms from "@/tools/customs/customs.vue";

export default {
  name: 'CircularDetails',
  components: {
    ZCustoms,
    ZProductCategory, ZCircularDocumentType, ZCircularProcessType, ZQuillEditor,
  },
  data() {
    return {
      Form: {
        Id: null,
        Title: null,
        Description: null,
        LetterNumber: null,
        IsActive: true,
        Date: null,
        ExpiryDate: null,
      },
      loading: false,
      attachment: null,
      objectUrl: null,
    }
  },
  computed: {
    // آدرس قابل‌مشاهده‌ی پیوست: فایلِ تازه انتخاب‌شده (object URL) یا پیوستِ ذخیره‌شده روی سرور
    attachmentUrl() {
      return this.objectUrl || this.Form.Attachment || null
    },
    attachmentName() {
      if (this.attachment) {
        return this.attachment.name
      }

      if (this.Form.Attachment) {
        const parts = this.Form.Attachment.split('/')
        return decodeURIComponent(parts[parts.length - 1])
      }

      return null
    },
    attachmentExt() {
      const name = this.attachmentName
      if (!name || !name.includes('.')) {
        return ''
      }

      return name.split('.').pop().toLowerCase()
    },
    attachmentIsImage() {
      return ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'].includes(this.attachmentExt)
    },
    attachmentIcon() {
      const ext = this.attachmentExt
      if (['pdf', 'doc', 'docx', 'txt', 'rtf'].includes(ext)) {
        return 'FileTextIcon'
      }
      if (['xls', 'xlsx', 'csv'].includes(ext)) {
        return 'GridIcon'
      }
      if (['zip', 'rar', '7z'].includes(ext)) {
        return 'ArchiveIcon'
      }

      return 'FileIcon'
    },
  },
  watch: {
    attachment(file) {
      if (this.objectUrl) {
        URL.revokeObjectURL(this.objectUrl)
        this.objectUrl = null
      }

      if (file) {
        this.objectUrl = URL.createObjectURL(file)
      }
    },
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    }
  },
  beforeDestroy() {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl)
    }
  },
  methods: {
    save() {
      let url = this.$api.circular.add
      if (this.$route.params.id) {
        url = this.$api.circular.update
      }

      const formData = new FormData(this.$refs.circularform)
      formData.append('Id', this.Form.Id)
      formData.append('IsActive', this.Form.IsActive)

      if (this.Form.Description) {
        formData.append('Description', this.Form.Description)
      }

      if (this.attachment) {
        formData.append('Attachment', this.attachment)
      }

      if (this.Form.Date) {
        formData.append('Date', this.Form.Date)
      }

      if (this.Form.ExpiryDate) {
        formData.append('ExpiryDate', this.Form.ExpiryDate)
      }

if (this.Form.CustomsId){
  this.Form.CustomsId.forEach((item, index) => {
    formData.append(`CustomsId`, item)
  })
}

      if (this.Form.ProductCategoryId){
        this.Form.ProductCategoryId.forEach((item, index) => {
          formData.append(`ProductCategoryId`, item)
        })
      }

      if (this.Form.CircularProcessTypeId){
        this.Form.CircularProcessTypeId.forEach((item, index) => {
          formData.append(`CircularProcessTypeId`, item)
        })
      }

      if (this.Form.CircularDocumentTypeId){
        this.Form.CircularDocumentTypeId.forEach((item, index) => {
          formData.append(`CircularDocumentTypeId`, item)
        })
      }

      this.loading = true
      this.$http.post(
        url, formData,
      )
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    onTagsPaste(event) {
      const clipboard = event.clipboardData
      if (!clipboard) {
        return
      }

      const text = clipboard.getData('text')
      // فقط وقتی متن چندخطی است دخالت می‌کنیم؛ پیست تک‌خطی رفتار عادی دارد
      if (!text || !/[\r\n]/.test(text)) {
        return
      }

      event.preventDefault()

      const newTags = text
        .split(/\r?\n/)
        .map(t => t.trim())
        .filter(t => t)

      if (!newTags.length) {
        return
      }

      if (!Array.isArray(this.Form.Tag)) {
        this.$set(this.Form, 'Tag', [])
      }

      newTags.forEach(tag => {
        if (!this.Form.Tag.includes(tag)) {
          this.Form.Tag.push(tag)
        }
      })
    },
    imageRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.Form.Image = fileReader.result
      }
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.circular.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
        })
    },
  },
}
</script>

<style scoped>
.image .media-body {
  align-self: flex-end;
}

/* چیپ پیش‌نمایش پیوست */
.attachment-preview {
  max-width: 100%;
  padding: 0.5rem 0.75rem;
  background-color: #fff;
  color: inherit;
  text-decoration: none !important;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.attachment-preview:hover {
  border-color: #7367f0 !important;
  box-shadow: 0 4px 14px rgba(115, 103, 240, 0.18);
  transform: translateY(-1px);
}

.attachment-thumb {
  width: 42px;
  height: 42px;
  min-width: 42px;
  border-radius: 0.357rem;
  background-color: rgba(115, 103, 240, 0.12);
  color: #7367f0;
  overflow: hidden;
}

.attachment-thumb-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.attachment-info {
  min-width: 0;
}

.attachment-name {
  font-weight: 600;
  color: #5e5873;
  word-break: break-word;
  line-height: 1.25;
}
</style>
